import type { FetchRequestError } from "@lib/errors";
import { FetchUserEncodedError } from "@lib/errors/FetchUserEncodedError";
import type { SHARED_CONSTANTS_ATTRIBUTION_INTEGRATION_ERRORS } from "@lib/shared_constants";
import sharedConstants from "@lib/shared_constants";
import type { ISODateTimeTzString } from "@lib/time";

export interface PartnerAttributionIntegration {
  c_id?: string;
  ag_id?: string;
  integration_id?: string;
  connected_by?: string;
  api_key?: string;
  connected_at?: ISODateTimeTzString;
}

export interface GetAlloysPartnerAttributionAppGroupIdResult {
  integration: PartnerAttributionIntegration | Record<string, never>;
}

export interface PostAlloysPartnerAttributionAppGroupIdResult {
  integration: PartnerAttributionIntegration;
}

interface AlloysPartnerAttributionAppGroupIdProps {
  /** The partner name (e.g., "airbridge") */
  partner: string;
  /** The app group ID */
  appGroupId: string;
}

export type PostAlloysPartnerAttributionAppGroupIdProps = AlloysPartnerAttributionAppGroupIdProps;

export type DeleteAlloysPartnerAttributionAppGroupIdResult = Record<string, never>;

export type DeleteAlloysPartnerAttributionAppGroupIdResultIntegrationNotFoundError = FetchUserEncodedError<
  SHARED_CONSTANTS_ATTRIBUTION_INTEGRATION_ERRORS["INTEGRATION_NOT_FOUND"]
>;

export type DeleteAlloysPartnerAttributionAppGroupIdResultErrors =
  DeleteAlloysPartnerAttributionAppGroupIdResultIntegrationNotFoundError;

export const isDeleteAlloysPartnerAttributionAppGroupIdResultError = (
  error: FetchRequestError
): error is DeleteAlloysPartnerAttributionAppGroupIdResultErrors => {
  return (
    error instanceof FetchUserEncodedError &&
    error.errorCode === sharedConstants.ATTRIBUTION_INTEGRATION_ERRORS.INTEGRATION_NOT_FOUND
  );
};

export type DeleteAlloysPartnerAttributionAppGroupIdProps = AlloysPartnerAttributionAppGroupIdProps;
